import commonMixin from '@/mixin/common'
import { getDetail, getProductList } from '@/api/server/product'
import { cartAdd } from '@/api/server/cart'
import CartBtn from '@/components/CartBtn'
import CartNumber from '@/components/CartNumber'
import BackPageFull from '@/components/BackPageFull'

import { getJssdk } from '@/api/server/wechat'
import wx from 'weixin-js-sdk'

export default {
  name: 'IndexPage',
  mixins: [commonMixin],
  data () {
    return {
      _id: null,
      info: [],
      num: 1,
      hots: [],
      cartShow: false,
      buy: 'addCart', //fastBuy
      screenWidth: document.body.clientWidth,
      fullUrl:
        window.location.protocol +
        '//' +
        window.location.hostname +
        this.$route.fullPath
    }
  },
  components: {
    CartBtn,
    CartNumber,
    BackPageFull
  },
  methods: {
    _jsSdkInit () {
      let fullUrl = this.fullUrl
      let query = {
        url: fullUrl
      }
      getJssdk(query).then(res => {
        if (res.code === 200 && res.data) {
          let jssdk = res.data
          let wxConfig = {
            debug: false,
            appId: jssdk.appId,
            timestamp: parseInt(jssdk.timestamp),
            nonceStr: jssdk.nonceStr,
            signature: jssdk.signature,
            // jsApiList: jssdk.jsApiList
            jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData']
          }
          wx.config(wxConfig)
          this.jsSdk = res.data
          wx.error(function (res) {
            console.log('err', res)
          })
          this._getWeChatShare()
        }
      })
    },
    _getWeChatShare () {
      let fullUrl = this.fullUrl
      //分享的参数
      let shareMsage = {
        title: '909数码',
        desc: this.info.title + '。只要：￥' + this.info.price,
        link: fullUrl,
        imgUrl: this.info.image
      }
      wx.ready(function () {
        // 分享给朋友 分享到QQ
        wx.updateAppMessageShareData({
          title: shareMsage.title, // 分享标题
          desc: shareMsage.desc, // 分享描述
          link: shareMsage.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
          imgUrl: shareMsage.imgUrl, // 分享图标
          success: function () {
            // 设置成功
            console.log('分享给朋友设置成功')
          }
        })
        // 分享到朋友圈 分享到QQ空间
        wx.updateTimelineShareData({
          title: shareMsage.desc, // 分享标题
          link: shareMsage.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
          imgUrl: shareMsage.imgUrl, // 分享图标
          success: function () {
            // 设置成功
            console.log('分享到朋友圈，设置成功')
          }
        })
      })
    },
    onAddCart (e) {
      this.cartShow = true
      this.buy = e
    },
    onCloseCart (show) {
      this.cartShow = show
    },
    onChangeNum (num) {
      this.cartShow = false
      this.num = num
      if (this.buy === 'addCart') {
        this.addCart()
      } else {
        this.fastBuy()
      }
    },
    addCart () {
      let num = this.num
      let id = this._id
      if (!id || !num) {
        this.warning('库存不足')
        return false
      }
      cartAdd(id, num).then(res => {
        if (res.code === 200) {
          this.success('加入购物车成功')
        } else {
          this.error(res.message)
        }
      })
    },
    fastBuy () {
      let num = this.num
      let id = this._id
      if (!id || !num) {
        this.warning('库存不足')
        return false
      }
      cartAdd(id, num).then(res => {
        if (res.code === 200) {
          this.$router.push({ name: 'order-submit' })
        } else {
          this.error(res.message)
        }
      })
    },
    _getDetail () {
      let query = {
        id: this._id
      }
      let that = this
      getDetail(query)
        .then(data => {
          if (data.code === 200 && data.data) {
            this.info = data.data
            that._jsSdkInit()
          } else {
            this.warning(data.message)
          }
        })
        .catch(e => {
          console.log('err', e)
        })
    },
    reset () {
      this.cartShow = false
      this.info = []
      this._getDetail()
      //this._getHot()
    },
    handleRoute (route) {
      if (route.name === 'detail') {
        let id = this.$route.query.id
        console.log('id', this.$route.query.id)
        if (!id) {
          this.warning('商品不存在')
          this.$route.push({ nam: 'login' })
        } else {
          this._id = id
        }
        this.reset()
      }
    }
  },
  watch: {
    $route (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}
